import React from 'react';

import _ from 'lodash';



// TODO: from Stripe API
const COUNTRIES = [
  'Australia', 'Austria',
  'Belgium', 'Brazil', 'Bulgaria',
  'Canada', 'Cyprus', 'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland', 'France',
  'Germany', 'Greece',
  'Hong Kong', 'Hungary',
  'India Preview', 'Ireland', 'Italy',
  'Japan',
  'Latvia', 'Lithuania', 'Luxembourg',
  'Malaysia', 'Malta', 'Mexico',
  'Netherlands', 'New Zealand', 'Norway',
  'Poland', 'Portugal',
  'Romania',
  'Singapore', 'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'Switzerland',
  'United Arab Emirates', 'United Kingdom', 'United States'
];

export function usePaymentCountrySelectField() {
  return React.useMemo(() => {
    return {
      loading: false,
      data: {
        enumValues: _.map(COUNTRIES, country => ({
          id: country,
          name: country,
          displayName: country
        }))
      }
    };
  }, []);
}
